// extracted by mini-css-extract-plugin
export default {"svg":"LoadingIcon_svg__qrLkP","circle":"LoadingIcon_circle__vTzBf","rotate":"LoadingIcon_rotate__OSLCt"};